export default "__VITE_ASSET__DufvAxZ8__"